import {
  fetchWithOOB,
  getCSRFToken,
  processOOBSwaps,
  processResponseTriggers,
} from "./htmx-helpers";
import { formatBytes } from "./utils";

export const registerReplaceModal = (Alpine: any) => {
  Alpine.data(
    "replaceAssetModal",
    (
      startedMsg = "Replacement started in background…",
      failedMsg = "Failed to start replacement",
    ) => ({
      deliverableID: null as string | null,
      groupID: null as string | null,
      assetID: null as string | null,
      filename: "",
      childCount: 0,
      selectedFile: null as File | null,
      propagate: true,
      isSubmitting: false,
      error: "",

      init() {
        // No-op init
      },

      open(
        deliverableID: string,
        groupID: string,
        id: string,
        filename: string,
        childCount: number,
      ) {
        this.deliverableID = deliverableID;
        this.groupID = groupID;
        this.assetID = id;
        this.filename = filename;
        this.childCount = childCount;
        this.selectedFile = null;
        this.propagate = true;
        this.isSubmitting = false;
        this.error = "";

        (document.getElementById("replace-asset-modal") as any)?.showModal();
      },

      close() {
        (document.getElementById("replace-asset-modal") as any)?.close();
      },

      handleFileSelect(event: any) {
        const file = event.target.files[0];
        if (file) {
          this.selectedFile = file;
        }
      },

      formatBytes(bytes: number) {
        return formatBytes(bytes);
      },

      async submit() {
        if (!this.selectedFile || !this.assetID || !this.deliverableID || !this.groupID) return;

        this.isSubmitting = true;
        this.error = "";

        try {
          // Hand off to global uploader
          // @ts-ignore - Alpine globals
          Alpine.store("uploader").addFiles([this.selectedFile], {
            type: "replace",
            deliverableId: this.deliverableID,
            groupId: this.groupID,
            assetId: this.assetID,
            propagate: this.propagate,
          });

          // Close modal immediately - uploader handles background processing
          this.close();

          // Trigger a toast notifying the user
          window.dispatchEvent(
            new CustomEvent("flash-message", {
              detail: {
                msg: startedMsg,
                type: "info",
              },
            }),
          );
        } catch (err: any) {
          console.error("[replaceAssetModal] Submit failed:", err);
          this.error = err.message || failedMsg;
          this.isSubmitting = false;
        }
      },
    }),
  );
};
